export default __webpack_public_path__ + "static/media/vomit.17e23b02.mp3";